import { Component, computed, effect, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { ComboPendingMessage, ComboValidationService } from '../../services/combo-validation.service';

@Component({
  selector: 'app-combo-guide-block',
  templateUrl: './combo-guide-block.component.html',
  styleUrl: './combo-guide-block.component.scss',
  standalone: false,
})
export class ComboGuideBlockComponent {
  private readonly comboValidation = inject(ComboValidationService);

  // Scrolling to the message's sub-section only makes sense on the page that actually
  // renders it (menu-list) - everywhere else this stays plain, unclickable text.
  @Input() clickable = false;
  @Output() messageClick = new EventEmitter<ComboPendingMessage>();

  private readonly messages = this.comboValidation.pendingMessages;
  private readonly index = signal(0);

  readonly isVisible = computed(() => this.messages().length > 0);
  readonly hasMultiple = computed(() => this.messages().length > 1);
  private readonly currentPendingMessage = computed(() => this.messages()[this.index()]);
  readonly currentMessage = computed(() => this.currentPendingMessage()?.text ?? '');

  constructor() {
    // A message can disappear (resolved, or its group stopped being active) out
    // from under whichever index the guest was cycling through.
    effect(() => {
      if (this.index() >= this.messages().length) {
        this.index.set(0);
      }
    });
  }

  onTextClick(): void {
    if (!this.clickable) return;

    const message = this.currentPendingMessage();
    if (message) this.messageClick.emit(message);
  }

  next(): void {
    this.index.update(i => (i + 1) % this.messages().length);
  }

  previous(): void {
    this.index.update(i => (i - 1 + this.messages().length) % this.messages().length);
  }
}
